module.exports = __webpack_public_path__ + "779d5c48c64bc02fcc75f2248ee5e195.gif";


//////////////////
// WEBPACK FOOTER
// ./node_modules/fg-frontend/components/CookiesPolicy4/img/motive.gif
// module id = 423
// module chunks = 86 87 88